export default __webpack_public_path__ + "static/media/PlayerStatisticsImage.72de2ccf.png";